import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

const RadioFieldDefinitionSchema = z.object({
  name: z.string(),
  label: z.string(),

  type: z.enum(['text', 'password', 'select', 'string', 'custom']),

  options: z.array(z.string()).optional(),
  default: z.string().optional(),
  disabled: z.boolean().optional(),
  placeholder: z.string().optional(),

  component: z.string().optional(),
  componentProps: z.any().optional(),
});

const RadioOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
  fields: z.array(RadioFieldDefinitionSchema).optional(),
});

export const RadioInputFieldUiOptionsSchema = z.object({
  options: z.array(RadioOptionSchema),
});

export type RadioFieldDefinition = z.infer<typeof RadioFieldDefinitionSchema>;
export type RadioOption = z.infer<typeof RadioOptionSchema>;
export type RadioInputFieldUiOptions = z.infer<
  typeof RadioInputFieldUiOptionsSchema
>;

export const RadioInputFieldSchema = makeFieldSchemaFromZod(
  z.record(z.string(), z.any()),
  RadioInputFieldUiOptionsSchema,
);

export type RadioInputFieldProps = typeof RadioInputFieldSchema.type;
